import React from 'react';
import '../../App.css';
import Cards from '../Cards';
import HeroSection from '../HeroSection';
import Main from './Main';
import Footer from '../Footer';

function Home() {
  return (
    <>
      <HeroSection />
      <Main />
      <Cards />
      <Footer />
    </>
  );
}

export default Home;
